const lottieFilePath = '/static/libs/lottie-web@5.11.0.min.js';
let lottiePromise: Promise<void>;

export function loadLottieOnce() {
  if (typeof window === 'undefined')
    return Promise.reject(new Error('Lottie can only load in the browser.'));

  if (!lottiePromise) {
    lottiePromise = new Promise((resolve, reject) => {
      if (document.head.querySelector(`script[src="${lottieFilePath}"]`)) {
        resolve(undefined);
      } else {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = reject;
        script.src = lottieFilePath;
        document.head.appendChild(script);
      }
    });
  }

  return lottiePromise;
}
